import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=c8db05fc&scoped=true"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=c8db05fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8db05fc",
  null
  
)

export default component.exports